/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S9_P1Inputs */

const tr_kullanim_s9_p1 = /** @type {(inputs: Kullanim_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket, Platform'u "OLDUĞU GİBİ" sunmaktadır. Platform'un kesintisiz ya da hatasız çalışacağını taahhüt etmemektedir.`)
};

const en_kullanim_s9_p1 = /** @type {(inputs: Kullanim_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company provides the Platform "AS IS". It does not warrant that the Platform will operate uninterrupted or error-free.`)
};

const de_kullanim_s9_p1 = /** @type {(inputs: Kullanim_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen stellt die Plattform "WIE BESEHEN" bereit. Es sichert nicht zu, dass die Plattform unterbrechungsfrei oder fehlerfrei funktioniert.`)
};

const ru_kullanim_s9_p1 = /** @type {(inputs: Kullanim_S9_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания предоставляет Платформу "КАК ЕСТЬ". Она не гарантирует бесперебойную или безошибочную работу Платформы.`)
};

/**
* | output |
* | --- |
* | "The Company provides the Platform \"AS IS\". It does not warrant that the Platform will operate uninterrupted or error-free." |
*
* @param {Kullanim_S9_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s9_p1 = /** @type {((inputs?: Kullanim_S9_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S9_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s9_p1(inputs)
	if (locale === "de") return de_kullanim_s9_p1(inputs)
	if (locale === "ru") return ru_kullanim_s9_p1(inputs)
	return tr_kullanim_s9_p1(inputs)
});